export const brandBlogRecommendations = [
  {
    "id": "article-057",
    "slug": "monthly-recommendation-9786269339341",
    "title": "大腦不喜歡你這樣學：從性格、節奏到環境，打造專屬你的最佳學習模式",
    "publisher": "策點文化",
    "isbn": "9786269339341",
    "coverImage": "/assets/books/9786269339341.jpg",
    "category": "科普知識",
    "tagline": "從理解大腦到認識自我，找出適合的學習方法",
    "publishDate": "2026-10-22",
    "excerpt": "從理解大腦到認識自我，找出適合的學習方法 掌握學習者、引導者與媒介的關係 建立真正有效且能長久維持的學習模式"
  },
  {
    "id": "article-058",
    "slug": "monthly-recommendation-9786264284608",
    "title": "有兵無糧銀，大明缺補給！帝國三百年邊防與財政危機：衛所變革×邊鎮經營×賦役失衡，從開國強盛到末世危局，解讀明朝國運轉折",
    "publisher": "複刻文化",
    "isbn": "9786264284608",
    "coverImage": "/assets/books/9786264284608.jpg",
    "category": "歷史",
    "tagline": "從軍糧與邊餉，看明代帝國如何被補給支撐",
    "publishDate": "2026-10-21",
    "excerpt": "從軍糧、漕運、屯田到邊餉， 後勤體系如何支撐明代疆域與軍事運作？ 當補給失衡、財政承壓，"
  },
  {
    "id": "article-059",
    "slug": "monthly-recommendation-9786264074407",
    "title": "戰事演義：歷代戰爭與著名戰役",
    "publisher": "千華駐科技",
    "isbn": "9786264074407",
    "coverImage": "/assets/books/9786264074407.jpg",
    "category": "歷史",
    "tagline": "從上古到近世，讀懂中國歷代戰爭與著名戰役",
    "publishDate": "2026-10-21",
    "excerpt": "本書按照中國歷史朝代順序，分為四個篇章：上古、中古、近古、近世。上古篇為先秦以前的戰役，本書中所介紹的有：少康復國之戰、鳴條之戰、牧野之戰、長勺之戰、城濮之戰、桂陵之戰和馬陵之戰、長平之戰。中古篇為秦漢到隋唐之間，書中包含的有：鉅鹿之戰、井陘之戰、垓下之戰、漠北大戰、官渡之戰、赤壁之戰、淝水之戰、建康之戰、太原之戰。近古篇主要為兩宋時期，本書所講述的包含：澶州之戰、采石之戰、襄樊之戰、崖山海戰。近世篇是從明代到清代，有：北京保衛戰、抗倭…"
  },
  {
    "id": "article-060",
    "slug": "monthly-recommendation-9786264710404",
    "title": "癌病辨治四十年，中醫腫瘤臨床實錄：培本健脾×調整免疫×祛瘀解毒×中西醫協同，凝聚四十餘年臨床診療經驗，完整呈現常見癌症的辨治原則與醫案實踐",
    "publisher": "崧燁文化",
    "isbn": "9786264710404",
    "coverImage": "/assets/books/9786264710404.jpg",
    "category": "醫療保健",
    "tagline": "從辨證到治癌，整理四十餘年中醫腫瘤臨床經驗",
    "publishDate": "2026-10-21",
    "excerpt": "從辯證到治癌，癌病辨治與醫案精粹！ 承古法、融新知，從中醫腫瘤學術思想到各系統癌症辨治 完整呈現肺癌、腸癌、乳癌、攝護腺癌及血液腫瘤的醫案心得"
  },
  {
    "id": "article-061",
    "slug": "monthly-recommendation-9786264284578",
    "title": "多面關公，走向華夏神壇的漫漫長路：從三國名將到千年武聖，重訪關羽的生平、功過與爭議，追索後世對「關公」形象的塑造與推崇",
    "publisher": "複刻文化",
    "isbn": "9786264284578",
    "coverImage": "/assets/books/9786264284578.jpg",
    "category": "宗教文化",
    "tagline": "從三國名將到千年武聖，看見關羽形象如何被塑造",
    "publishDate": "2026-10-14",
    "excerpt": "他是帝，是聖，是神 受萬民香火，享千年尊崇 頭枕洛陽，身臥當陽，魂歸故里"
  },
  {
    "id": "article-062",
    "slug": "monthly-recommendation-9786267997314",
    "title": "別再把忙碌當成上進！富比士職場選擇學：判斷×自律×選擇×合作，看懂在AI時代真正拉開差距的工作能力",
    "publisher": "崧博出版",
    "isbn": "9786267997314",
    "coverImage": "/assets/books/9786267997314.jpg",
    "category": "商業理財",
    "tagline": "做得更多，不一定走得更遠？先學會選擇什麼值得做",
    "publishDate": "2026-10-14",
    "excerpt": "做得更多，不一定走得更遠？ 有些事根本不值得做！ 當所有人都在追求高效率，"
  },
  {
    "id": "article-063",
    "slug": "monthly-recommendation-9786264710336",
    "title": "看！這就是元素週期表：從黃金夢到人造元素，人類追尋物質祕密的漫長旅程",
    "publisher": "崧燁文化",
    "isbn": "9786264710336",
    "coverImage": "/assets/books/9786264710336.jpg",
    "category": "科普知識",
    "tagline": "從週期表出發，追索元素的發現、命名與應用",
    "publishDate": "2026-10-14",
    "excerpt": "小小一張週期表，真的寫下所有元素了嗎？ 科學家是如何「創造」新元素？ 銫、氟、鈾……重新認識那些一碰就爆炸與不碰也爆炸的危險「分子」！"
  },
  {
    "id": "article-064",
    "slug": "monthly-recommendation-9786269326532",
    "title": "一葉懂茶，茶出400種知識：英國伯爵茶、阿根廷瑪黛茶、日本玄米茶、臺灣泡沫紅茶……完整認識所有名茶、茶器與茶事",
    "publisher": "策點文化",
    "isbn": "9786269326532",
    "coverImage": "/assets/books/9786269326532.jpg",
    "category": "飲食文化",
    "tagline": "從一片茶葉出發，讀懂品種、產地、工藝與風味",
    "publishDate": "2026-10-07",
    "excerpt": "從一片茶葉出發，讀懂品種、產地、工藝與風味之間的關聯 由茶園走進茶席，掌握選茶、泡茶、品茶及茶文化的完整知識 ▎從一片茶葉看見完整的茶世界"
  },
  {
    "id": "article-065",
    "slug": "monthly-recommendation-9786264710268",
    "title": "空腹斷食養身，讓身體「適度挨餓」！斷食原理、代謝機制、營養補充、細胞自噬……認識空腹與斷食的運作機制，重新建立健康飲食新生活！",
    "publisher": "崧燁文化",
    "isbn": "9786264710268",
    "coverImage": "/assets/books/9786264710268.jpg",
    "category": "醫療保健",
    "tagline": "空腹不是挨餓，而是重新安排身體與飲食的節奏",
    "publishDate": "2026-10-07",
    "excerpt": "空腹，是身體的另一種休息！ 脂肪代謝×免疫調節×細胞修復…… 理解常見斷食方式，搭配營養、運動與生活習慣，"
  },
  {
    "id": "article-066",
    "slug": "monthly-recommendation-9786267866351",
    "title": "富春山居圖，畫中之蘭亭：走進古代文人的精神世界，探索六百年傳世經典的技法與意境",
    "publisher": "沐燁文化",
    "isbn": "9786267866351",
    "coverImage": "/assets/books/9786267866351.jpg",
    "category": "藝術文化",
    "tagline": "一卷山水，藏盡黃公望筆下的天地與人生",
    "publishDate": "2026-10-07",
    "excerpt": "一卷山水，藏盡黃公望筆下的天地與人生 循著富春江徐徐展卷，讀懂中國山水畫的千年意境 ▎一卷山水，展開中國畫的觀看之道"
  },
  {
    "id": "article-067",
    "slug": "monthly-recommendation-9786264085601",
    "title": "量子科技正在改變世界，從粒子走向晶片：看懂量子科技真正改變了什麼！量子點×自旋電子×奈米探針×量子通訊×量子電腦，從百年科學理論到現代產業應用",
    "publisher": "財經錢線",
    "isbn": "9786264085601",
    "coverImage": "/assets/books/9786264085601.jpg",
    "category": "科普知識",
    "tagline": "從量子原理讀到科技應用，理解下一波產業變革",
    "publishDate": "2026-10-07",
    "excerpt": "材料×測量×奈米科技×通訊×運算×晶片…… 少量簡單公式， 帶你從量子原理讀到科技應用與產業發展，"
  },
  {
    "id": "article-001",
    "slug": "monthly-recommendation-9786269326556",
    "title": "別把健康交給謠言：從魚油、維他命到藥膳偏方，藥理教授破解食補話術與餐桌迷思",
    "publisher": "策點文化",
    "isbn": "9786269326556",
    "coverImage": "/assets/books/9786269326556.jpg",
    "category": "醫療保健",
    "tagline": "健康食品最會說故事，身體卻只相信科學； 一口吃下去之前，先看懂它到底憑什麼有效！ ▎從餐桌到藥櫃，健康常識其實沒那麼簡單 大蒜素、納豆激酶、月子水、南瓜壯陽、石榴補身、魚油護血管……這些看似熟悉的健康話題，常常以「聽說有效」、「大家都這樣吃」的方式進入日常生活。可是一旦追問有效成分是什麼、劑量...",
    "publishDate": "2026-10-01",
    "excerpt": "健康食品最會說故事，身體卻只相信科學； 一口吃下去之前，先看懂它到底憑什麼有效！ ▎從餐桌到藥櫃，健康常識其實沒那麼簡單 大蒜素、納豆激酶、月子水、南瓜壯陽、石榴補身、魚油護血管……這些看似熟悉的健康話題，常常以「聽說有效」、「大家都這樣吃」的方式進入日常生活。可是一旦追問有效成分是什麼、劑量多少才有意義、風險又藏在哪裡，許多流行說法就開始站不住腳。本書從健康食品、維他命、家常菜、藥膳、飲品到癌症飲食，以幽默而具科學精神的方式，拆解那些…"
  },
  {
    "id": "article-002",
    "slug": "monthly-recommendation-9786264284509",
    "title": "江山易主，五代十國與宋的那些人那些事：石敬瑭、李存勗、趙匡胤、李煜、岳飛、趙構……從五代十國到兩宋興亡，透過帝王、文臣與武將的命運，看繁華盛世背後的人事無常",
    "publisher": "複刻文化",
    "isbn": "9786264284509",
    "coverImage": "/assets/books/9786264284509.jpg",
    "category": "商業理財",
    "tagline": "藩鎮割據、黃袍加身、靖康之變、南宋覆滅…… 看帝王將相在權力、戰爭與制度之間寫下的歷史轉折 ▎從五代亂局走向兩宋太平 五代十國，是中國歷史上政權更迭最頻繁、戰亂最密集的時期之一。短短數十年間，中原先後歷經後梁、後唐、後晉、後漢、後周，南北各地亦割據紛爭，武將擁兵自重，皇位與疆土往往取決於兵力強...",
    "publishDate": "2026-09-30",
    "excerpt": "藩鎮割據、黃袍加身、靖康之變、南宋覆滅…… 看帝王將相在權力、戰爭與制度之間寫下的歷史轉折 ▎從五代亂局走向兩宋太平 五代十國，是中國歷史上政權更迭最頻繁、戰亂最密集的時期之一。短短數十年間，中原先後歷經後梁、後唐、後晉、後漢、後周，南北各地亦割據紛爭，武將擁兵自重，皇位與疆土往往取決於兵力強弱。石敬瑭割讓幽雲十六州、桑維翰奔走契丹、李存勗由盛轉亡，皆成為這個時代的重要縮影。本書從一個個人物與歷史瞬間切入，重新梳理五代至兩宋之際的政局變…"
  },
  {
    "id": "article-003",
    "slug": "monthly-recommendation-9786264710183",
    "title": "「1+1」也不簡單，100個數學基本問題：黎曼猜想、歌德巴赫猜想、費馬定理……解答之前，先挑戰看懂題目！",
    "publisher": "崧燁文化",
    "isbn": "9786264710183",
    "coverImage": "/assets/books/9786264710183.jpg",
    "category": "科普知識",
    "tagline": "問題有一百個，答案卻不只一百種？ 從牛吃草到柯尼斯堡七橋 看懂題目，只算過了第一關！ ▎一百個問題，打開數學思考的大門 數學不只是公式、定理與計算，更是一連串從問題出發的思考過程。本書專為高中生、大學低年級學生，以及對數學抱有興趣的青少年讀者編寫，精選100個兼具經典性、趣味性與挑戰性的數學問...",
    "publishDate": "2026-09-30",
    "excerpt": "問題有一百個，答案卻不只一百種？ 從牛吃草到柯尼斯堡七橋 看懂題目，只算過了第一關！ ▎一百個問題，打開數學思考的大門 數學不只是公式、定理與計算，更是一連串從問題出發的思考過程。本書專為高中生、大學低年級學生，以及對數學抱有興趣的青少年讀者編寫，精選100個兼具經典性、趣味性與挑戰性的數學問題。這些題目有些看似簡單，真正深入思考後，卻會發現其中藏著巧妙的推理方法與數學觀念；有些甚至曾吸引歷代數學家投入研究。讀者可以從一道道問題開始，嘗…"
  },
  {
    "id": "article-004",
    "slug": "monthly-recommendation-9786267866337",
    "title": "什麼是科普？走出象牙塔的科學知識：KISS原則×7C法則×故事表達×信任建立……結合科學傳播研究與媒體實務，掌握讓知識走向大眾的方法",
    "publisher": "沐燁文化",
    "isbn": "9786267866337",
    "coverImage": "/assets/books/9786267866337.jpg",
    "category": "醫療保健",
    "tagline": "真正的科普，竟是一門「溝通學」？ ────別只告訴我答案，讓我理解科學！ 認知偏誤、動機性推理、信任框架、閱聽者差異…… 從資訊選擇到公眾理解， 讓科學真正走出學術圈、走進大眾的日常生活！ 【從普及知識走向理解科學】 科普究竟只是把艱深知識說得簡單，還是應該讓更多人真正理解科學？本書從科學普及...",
    "publishDate": "2026-09-30",
    "excerpt": "真正的科普，竟是一門「溝通學」？ ────別只告訴我答案，讓我理解科學！ 認知偏誤、動機性推理、信任框架、閱聽者差異…… 從資訊選擇到公眾理解， 讓科學真正走出學術圈、走進大眾的日常生活！ 【從普及知識走向理解科學】 科普究竟只是把艱深知識說得簡單，還是應該讓更多人真正理解科學？本書從科學普及與科學傳播的關係出發，重新思考科普的目的與價值。作者指出，科學不只存在於實驗室與研究論文中，也早已滲入導航、醫療、飲食、科技產品等日常生活。科普因…"
  },
  {
    "id": "article-005",
    "slug": "monthly-recommendation-9786269326549",
    "title": "人類迷因速讀，看懂行為、情緒與人格的心理學底層邏輯：討好、腦補、暈船、跟風、玻璃心……從人格面具到群體迷思，拆解人類日常失控的心理機制",
    "publisher": "策點文化",
    "isbn": "9786269326549",
    "coverImage": "/assets/books/9786269326549.jpg",
    "category": "醫療保健",
    "tagline": "從記憶、感知、情緒到人格 理解人類為什麼會這樣思考與行動 一部寫給普通讀者的心理學入門 帶你看見日常選擇背後的原因 【從日常經驗進入心理學】 心理學並非遙遠艱深的理論，而是理解人如何思考、感受、記憶、判斷與互動的一套方法。從看見一張臉、聽見一句話、記住某個片段，到面對他人的眼神、語氣與沉默，人...",
    "publishDate": "2026-09-24",
    "excerpt": "從記憶、感知、情緒到人格 理解人類為什麼會這樣思考與行動 一部寫給普通讀者的心理學入門 帶你看見日常選擇背後的原因 【從日常經驗進入心理學】 心理學並非遙遠艱深的理論，而是理解人如何思考、感受、記憶、判斷與互動的一套方法。從看見一張臉、聽見一句話、記住某個片段，到面對他人的眼神、語氣與沉默，人的每一次反應背後，都有認知、情緒與社會經驗共同作用。這部心理學入門讀物以清楚易懂的方式，帶領讀者從基本概念出發，認識心理學的發展脈絡、主要分支與研…"
  },
  {
    "id": "article-006",
    "slug": "monthly-recommendation-9786264284493",
    "title": "輕鬆讀懂《商君書》：二十六篇還原商鞅的治國思想，看一場變法如何重塑利益秩序並奠定秦國強盛基礎",
    "publisher": "複刻文化",
    "isbn": "9786264284493",
    "coverImage": "/assets/books/9786264284493.jpg",
    "category": "心理學",
    "tagline": "制度設計、利益導向、賞罰執行、改革推動…… 從《商君書》重新理解秦國崛起的制度基礎， 以及法家如何思考人性、利益、賞罰與國家治理 ▎從時代背景理解法家思想 《商君書》是先秦法家重要典籍之一，全書圍繞治國、用法、農戰、賞刑、君臣、權術與制度設計等問題展開。本書前言首先從春秋戰國的社會變遷說明法家...",
    "publishDate": "2026-09-23",
    "excerpt": "制度設計、利益導向、賞罰執行、改革推動…… 從《商君書》重新理解秦國崛起的制度基礎， 以及法家如何思考人性、利益、賞罰與國家治理 ▎從時代背景理解法家思想 《商君書》是先秦法家重要典籍之一，全書圍繞治國、用法、農戰、賞刑、君臣、權術與制度設計等問題展開。本書前言首先從春秋戰國的社會變遷說明法家思想產生的背景，認為隨著生產力發展、諸侯兼併與戰爭加劇，原有依靠禮俗與自我約束維持的社會秩序逐漸失去作用，因此需要更具強制性的制度與法律來整頓社會…"
  },
  {
    "id": "article-007",
    "slug": "monthly-recommendation-9786264710152",
    "title": "延壽食譜，今天也要好好吃飯！認識四性五味，順應四時節氣，精選實用食療方，在一粥一飯之間兼顧美味與調養",
    "publisher": "崧燁文化",
    "isbn": "9786264710152",
    "coverImage": "/assets/books/9786264710152.jpg",
    "category": "醫療保健",
    "tagline": "內科、外科、男科、婦科、兒科、五官科、皮膚科…… 常見健康問題一次收錄，為不同需求找到合宜的食療方式 選對食材、懂得搭配，用家常料理把健康慢慢吃回來！ 【從飲食了解讀懂食療】 食療將調養身體的觀念落實在每天的飲食之中。本書從「藥食同源」談起，帶領讀者認識中醫傳統食療的發展脈絡，並以淺顯方式整理...",
    "publishDate": "2026-09-23",
    "excerpt": "內科、外科、男科、婦科、兒科、五官科、皮膚科…… 常見健康問題一次收錄，為不同需求找到合宜的食療方式 選對食材、懂得搭配，用家常料理把健康慢慢吃回來！ 【從飲食了解讀懂食療】 食療將調養身體的觀念落實在每天的飲食之中。本書從「藥食同源」談起，帶領讀者認識中醫傳統食療的發展脈絡，並以淺顯方式整理四性、五味、五色等重要概念，說明不同食材各有其特性，如何選擇、搭配，也會隨體質、季節與生活環境而有所不同。書中進一步介紹辨證用膳、因人用膳、因時用…"
  },
  {
    "id": "article-008",
    "slug": "monthly-recommendation-9786264540186",
    "title": "養好你的膝關節，老了才能趴趴走！從人體避震器到人工關節，一本讀懂膝關節保養與治療",
    "publisher": "樂律文化",
    "isbn": "9786264540186",
    "coverImage": "/assets/books/9786264540186.jpg",
    "category": "醫療保健",
    "tagline": "一本看懂膝蓋痛從何而來、該如何治療與保養的實用科普書。 從退化性關節炎、類風濕、痛風到人工關節，帶你破解迷思 ▎本書以「膝關節是人體避震器」為核心比喻，從結構、疾病辨析、治療路徑到日常保養，建立一套完整且實用的膝關節健康知識。開篇先介紹膝關節的基本構造，包括股骨、脛骨、髕骨、軟骨、滑膜、關節囊...",
    "publishDate": "2026-09-23",
    "excerpt": "一本看懂膝蓋痛從何而來、該如何治療與保養的實用科普書。 從退化性關節炎、類風濕、痛風到人工關節，帶你破解迷思 ▎本書以「膝關節是人體避震器」為核心比喻，從結構、疾病辨析、治療路徑到日常保養，建立一套完整且實用的膝關節健康知識。開篇先介紹膝關節的基本構造，包括股骨、脛骨、髕骨、軟骨、滑膜、關節囊、韌帶、肌肉與半月板。這些組織分別負責承重、潤滑、穩定、減震與活動，讓人能完成行走、上下樓、坐下與起立等日常動作。當軟骨磨損、滑膜發炎、韌帶受傷或…"
  },
  {
    "id": "article-009",
    "slug": "monthly-recommendation-9786269326525",
    "title": "「超級投資者」的盈利之道，華特．施洛斯的價值投資法：安全邊際×低估值選股×分散持股……師承葛拉漢、比肩巴菲特，以極簡選股法穿越市場趨勢的「華爾街掃地僧」！",
    "publisher": "策點文化",
    "isbn": "9786269326525",
    "coverImage": "/assets/books/9786269326525.jpg",
    "category": "商業理財",
    "tagline": "從大蕭條經驗到葛拉漢門徒， 不靠預測、不追熱門、不聽消息…… 以安全邊際與紀律累積長期報酬， 華爾街「掃地僧」──華特．施洛斯的散戶投資學！ ◎買的時候就要把錢賺了！ ◎投資的第一原則是「不虧錢」！ 華特．施洛斯，身為「華爾街教父」──班傑明．葛拉漢的嫡傳弟子、華倫．巴菲特的同門師兄，他是「撿...",
    "publishDate": "2026-09-17",
    "excerpt": "從大蕭條經驗到葛拉漢門徒， 不靠預測、不追熱門、不聽消息…… 以安全邊際與紀律累積長期報酬， 華爾街「掃地僧」──華特．施洛斯的散戶投資學！ ◎買的時候就要把錢賺了！ ◎投資的第一原則是「不虧錢」！ 華特．施洛斯，身為「華爾街教父」──班傑明．葛拉漢的嫡傳弟子、華倫．巴菲特的同門師兄，他是「撿菸蒂股」策略最忠實的踐行者，沒有高學歷，沒有研究團隊，也沒有豪華辦公室，卻在長達47年的職業投資生涯中，創造了年化收益率高達20.1％的驚人業績，…"
  },
  {
    "id": "article-010",
    "slug": "monthly-recommendation-9786264710121",
    "title": "心腦血管疾病管理全書：血壓×血脂×血糖×心律×睡眠×飲食×運動，從日常風險到急性發作一次看懂",
    "publisher": "崧燁文化",
    "isbn": "9786264710121",
    "coverImage": "/assets/books/9786264710121.jpg",
    "category": "醫療保健",
    "tagline": "多年累積的危險因子，終於突破血管防線 血壓高一點沒關係？血脂不痛不癢就不用管？ 心肌梗塞與腦中風，其實皆有跡可循── 從血管斑塊、血栓到心腦急症，真正的預防其實早該開始 重新看懂心腦血管疾病，把健康主動權掌握在自己手中！ ▎心腦血管疾病，真的都是「突然發作」嗎？ 胸痛、心悸、呼吸困難、頭暈，甚...",
    "publishDate": "2026-09-16",
    "excerpt": "多年累積的危險因子，終於突破血管防線 血壓高一點沒關係？血脂不痛不癢就不用管？ 心肌梗塞與腦中風，其實皆有跡可循── 從血管斑塊、血栓到心腦急症，真正的預防其實早該開始 重新看懂心腦血管疾病，把健康主動權掌握在自己手中！ ▎心腦血管疾病，真的都是「突然發作」嗎？ 胸痛、心悸、呼吸困難、頭暈，甚至急性心肌梗塞、腦中風與猝死，看似來得措手不及，背後卻往往經歷了漫長的累積。本書從心血管與腦血管疾病的定義、分類與危害談起，帶領讀者理解動脈粥狀硬…"
  },
  {
    "id": "article-011",
    "slug": "monthly-recommendation-9786267866313",
    "title": "丹青美學：漢魏墓室×唐宋寺觀×元明廟宇×民國民居，走進古代壁畫的千年長卷，看見神佛之外的人間煙火",
    "publisher": "沐燁文化",
    "isbn": "9786267866313",
    "coverImage": "/assets/books/9786267866313.jpg",
    "category": "商業理財",
    "tagline": "神佛仙真×帝王將相×農耕勞作×市井生活 走進古代壁畫的千年長卷 跨越漢魏至民國的丹青世界 ▎穿越千年，在壁上讀一部古代藝術史 一面斑駁的牆壁，可以留下多少歷史？本書以時間為軸，從漢魏一路寫至民國，走訪墓葬、寺觀與民居中的珍貴壁畫，梳理跨越千餘年的繪畫發展脈絡。從漢魏的古樸雄健、唐代的雍容華麗，...",
    "publishDate": "2026-09-16",
    "excerpt": "神佛仙真×帝王將相×農耕勞作×市井生活 走進古代壁畫的千年長卷 跨越漢魏至民國的丹青世界 ▎穿越千年，在壁上讀一部古代藝術史 一面斑駁的牆壁，可以留下多少歷史？本書以時間為軸，從漢魏一路寫至民國，走訪墓葬、寺觀與民居中的珍貴壁畫，梳理跨越千餘年的繪畫發展脈絡。從漢魏的古樸雄健、唐代的雍容華麗，到宋遼金元的多元風貌，再至明清時期日益豐富的題材與表現，歷代畫工以線條與色彩，在牆壁上留下各自時代的印記。這些無法輕易移動、與建築空間緊密相連的繪…"
  },
  {
    "id": "article-012",
    "slug": "monthly-recommendation-9786267782606",
    "title": "解題力，數學思想方法的運用：從幾何、代數、微積分到現代數學基礎，掌握公式背後的邏輯與結構",
    "publisher": "機曜文化",
    "isbn": "9786267782606",
    "coverImage": "/assets/books/9786267782606.jpg",
    "category": "商業理財",
    "tagline": "從數學史到思想方法，讀懂公式背後的邏輯脈絡 以抽象、歸納、證明與建模，建立清晰解題思維 ▎從數學史看見思想的形成 數學並非只是一套計算技巧，也不僅存在於公式、定理與符號之中。它更像是一種人類理解世界、整理問題、建立秩序的思想方式。從記數、算術、幾何到代數，數學的發展始終伴隨著人類對數量、形狀、...",
    "publishDate": "2026-09-16",
    "excerpt": "從數學史到思想方法，讀懂公式背後的邏輯脈絡 以抽象、歸納、證明與建模，建立清晰解題思維 ▎從數學史看見思想的形成 數學並非只是一套計算技巧，也不僅存在於公式、定理與符號之中。它更像是一種人類理解世界、整理問題、建立秩序的思想方式。從記數、算術、幾何到代數，數學的發展始終伴隨著人類對數量、形狀、變化與結構的追問。全書以數學認知作為開端，先帶領讀者理解數學的研究對象、內容分支、突出特性與哲學依據，再進一步說明數學在人類知識體系中的地位與作用…"
  },
  {
    "id": "article-013",
    "slug": "monthly-recommendation-9786264284400",
    "title": "裴斐的李白十論：歷代評價、生平考辨、政治思想與詩歌藝術──從社會歷史脈絡重新理解李白的十個論題",
    "publisher": "複刻文化",
    "isbn": "9786264284400",
    "coverImage": "/assets/books/9786264284400.jpg",
    "category": "商業理財",
    "tagline": "濟世抱負、仕途挫折、浪漫想像、山水遊仙…… 在李白豪放飄逸的詩歌世界，讀見深沉的失意與時代憂憤 ▎重新定位李白的歷史形象 本書收錄裴斐十篇研究李白的論文，從歷代評價、生平事蹟、思想矛盾到各類詩歌逐層展開。作者先梳理唐宋以來「抑李揚杜」、「李杜並重」與「揚李抑杜」等評價脈絡，指出歷代評論雖普遍承...",
    "publishDate": "2026-09-09",
    "excerpt": "濟世抱負、仕途挫折、浪漫想像、山水遊仙…… 在李白豪放飄逸的詩歌世界，讀見深沉的失意與時代憂憤 ▎重新定位李白的歷史形象 本書收錄裴斐十篇研究李白的論文，從歷代評價、生平事蹟、思想矛盾到各類詩歌逐層展開。作者先梳理唐宋以來「抑李揚杜」、「李杜並重」與「揚李抑杜」等評價脈絡，指出歷代評論雖普遍承認李白非凡的天才、豪放飄逸的風格與傳奇身世，卻常忽略其作品與社會生活的關係。全書因此以社會歷史背景為主要觀察角度，重新說明李白的政治抱負、人生選擇…"
  },
  {
    "id": "article-014",
    "slug": "monthly-recommendation-9786264085427",
    "title": "當創新打破舊經濟！熊彼得《經濟發展理論》大眾版：新組合×企業家×信用資本，看懂新玩家崛起、舊巨頭失速與產業洗牌",
    "publisher": "財經錢線",
    "isbn": "9786264085427",
    "coverImage": "/assets/books/9786264085427.jpg",
    "category": "商業理財",
    "tagline": "【寫給想看懂產業變動，而不只想追熱門名詞的你】 一項新技術，為什麼能讓整個產業重新洗牌？一家新創，為什麼有時能撼動巨頭，有時卻只留下泡沫？當資金、人才與市場一起湧向新機會，繁榮背後又藏著什麼代價？ ▎經濟真正改變的時刻熊彼得關心的核心問題，是「舊秩序如何被打破」。本書從《經濟發展理論》出發，帶...",
    "publishDate": "2026-09-09",
    "excerpt": "【寫給想看懂產業變動，而不只想追熱門名詞的你】 一項新技術，為什麼能讓整個產業重新洗牌？一家新創，為什麼有時能撼動巨頭，有時卻只留下泡沫？當資金、人才與市場一起湧向新機會，繁榮背後又藏著什麼代價？ ▎經濟真正改變的時刻熊彼得關心的核心問題，是「舊秩序如何被打破」。本書從《經濟發展理論》出發，帶讀者看見日常經濟如何沿著既有軌道運作，又如何因為新產品、新方法、新市場、新供應來源與新組織形式出現，被迫重新排列。當資源離開原本用途，價格、工作、…"
  },
  {
    "id": "article-015",
    "slug": "monthly-recommendation-9786267940099",
    "title": "慰安婦朴永心，被戰爭改寫的一生：戰爭記憶×倖存者口述×遺址調查……一張戰地照片、一名朝鮮少女與日軍「慰安婦」制度的歷史追查",
    "publisher": "山頂視角",
    "isbn": "9786267940099",
    "coverImage": "/assets/books/9786267940099.jpg",
    "category": "科普知識",
    "tagline": "跨越朝鮮、南京與滇西的受難足跡， 以一張美國國家檔案館的戰地影像， 揭開日軍「慰安婦」制度下的生命傷痕 【一張照片揭開的歷史真相】 本書以美國國家檔案館保存的一張戰地照片為起點。照片中，一名懷孕的朝鮮籍「慰安婦」在滇緬戰場獲救，她就是朴永心。作者從照片的發現、人物身分的辨認與史料追查出發，說明...",
    "publishDate": "2026-09-09",
    "excerpt": "跨越朝鮮、南京與滇西的受難足跡， 以一張美國國家檔案館的戰地影像， 揭開日軍「慰安婦」制度下的生命傷痕 【一張照片揭開的歷史真相】 本書以美國國家檔案館保存的一張戰地照片為起點。照片中，一名懷孕的朝鮮籍「慰安婦」在滇緬戰場獲救，她就是朴永心。作者從照片的發現、人物身分的辨認與史料追查出發，說明日軍「慰安婦」制度的形成、運作方式及受害規模，並逐步還原朴永心從朝鮮被誘騙、押送至中國，遭受長期囚禁與性暴力的經歷。透過檔案文獻、戰地影像、口述證…"
  },
  {
    "id": "article-016",
    "slug": "monthly-recommendation-9786269312894",
    "title": "行為可以被預測！別輸在判斷人心的起點：從性格、表情到肢體語言，秒懂對方潛臺詞",
    "publisher": "策點文化",
    "isbn": "9786269312894",
    "coverImage": "/assets/books/9786269312894.jpg",
    "category": "醫療保健",
    "tagline": "人心從不只寫在語言裡，也寫在眼神、姿態與沉默之中 學會觀察行為，就能更接近一個人的真實內在 ▎從九型人格出發，讀懂人與人之間的差異 每個人都有自己的行為模式，也都有不容易被看見的心理底色。有人追求完美，總在細節裡反覆確認；有人習慣付出，卻常在關係裡忽略自己的需求；有人渴望成功，把目標看得比情感...",
    "publishDate": "2026-09-03",
    "excerpt": "人心從不只寫在語言裡，也寫在眼神、姿態與沉默之中 學會觀察行為，就能更接近一個人的真實內在 ▎從九型人格出發，讀懂人與人之間的差異 每個人都有自己的行為模式，也都有不容易被看見的心理底色。有人追求完美，總在細節裡反覆確認；有人習慣付出，卻常在關係裡忽略自己的需求；有人渴望成功，把目標看得比情感更重要；也有人敏感、懷疑、冷靜、衝動、強勢或溫和，在不同情境中展現出截然不同的性格面貌。這些差異並非偶然，而是人格、經驗、情緒與社會互動共同形成的…"
  },
  {
    "id": "article-017",
    "slug": "monthly-recommendation-9786269326518",
    "title": "量子力學比你想的更簡單：少一點公式，多一點理解！不懂高深數學，也能抓住量子力學的重要觀念",
    "publisher": "策點文化",
    "isbn": "9786269326518",
    "coverImage": "/assets/books/9786269326518.jpg",
    "category": "科普知識",
    "tagline": "微觀粒子能「穿牆」，人也有可能嗎？ 是什麼現象讓愛因斯坦無法接受？ 比電影更科幻，歡迎進入微觀尺度的現實！ ▎定位與目的本書為量子力學入門，專為非物理專業讀者撰寫。全書不試圖培養計算能力，而是著重建立對量子力學基本原理的理解，幫助讀者掌握現代科學中重要概念，提升科學素養。作者強調量子力學與經典...",
    "publishDate": "2026-09-03",
    "excerpt": "微觀粒子能「穿牆」，人也有可能嗎？ 是什麼現象讓愛因斯坦無法接受？ 比電影更科幻，歡迎進入微觀尺度的現實！ ▎定位與目的本書為量子力學入門，專為非物理專業讀者撰寫。全書不試圖培養計算能力，而是著重建立對量子力學基本原理的理解，幫助讀者掌握現代科學中重要概念，提升科學素養。作者強調量子力學與經典物理在基石上的根本差異，並從牛頓力學在微觀領域的失效出發，引導讀者進入新的理論框架。 ▎架構與脈絡全書同時敘述歷史與介紹概念。首先說明經典物理學的…"
  },
  {
    "id": "article-018",
    "slug": "monthly-recommendation-9786264284349",
    "title": "「儒林」真相，科舉制度下的士人百態：功名浮沉×人文風骨×思想流變，破解八股迷局，還原知識分子的精神世界",
    "publisher": "崧燁文化",
    "isbn": "9786264284349",
    "coverImage": "/assets/books/9786264284349.jpg",
    "category": "醫療保健",
    "tagline": "以歷史考證結合文本細讀，重新解讀《儒林外史》的真正價值 從科舉制度切入，解析明清士人文化與中國知識傳統的演變 ▎透視科舉制度，重返《儒林外史》的歷史現場 《儒林外史》向來被視為諷刺小說經典，然而其價值遠不止於人物刻畫與世態描摹。本書立足於明代科舉制度與歷史文獻，結合《明實錄》、《日知錄》、《維...",
    "publishDate": "2026-09-02",
    "excerpt": "以歷史考證結合文本細讀，重新解讀《儒林外史》的真正價值 從科舉制度切入，解析明清士人文化與中國知識傳統的演變 ▎透視科舉制度，重返《儒林外史》的歷史現場 《儒林外史》向來被視為諷刺小說經典，然而其價值遠不止於人物刻畫與世態描摹。本書立足於明代科舉制度與歷史文獻，結合《明實錄》、《日知錄》、《維南雍志》等史料，講述小說中的年代背景、歷史人物與真實事件，還原嘉靖、隆慶、萬曆以降的科舉生態，揭示吳敬梓如何將歷史、制度與文學巧妙融合，使虛構情節…"
  },
  {
    "id": "article-019",
    "slug": "monthly-recommendation-9786267782583",
    "title": "AI與BI，腦機之間，人工智慧如何理解生物大腦？感知編碼×持續學習×腦網路建模……從感知、情緒、語言到數位孿生腦，解析生物智慧與機器智慧的雙向啟發",
    "publisher": "機曜文化",
    "isbn": "9786267782583",
    "coverImage": "/assets/books/9786267782583.jpg",
    "category": "醫療保健",
    "tagline": "從生物腦到數位腦， 人腦如何啟發人工智慧，人工智慧又如何推動神經科學研究？ 從人腦功能、神經表徵到深度學習與生成模型的跨領域解析 【從人腦到機器，重新追問智慧本質】 人類對智慧的探索，歷經萬物有靈、機械自動裝置、神經科學與人工智慧等不同階段。隨著大型語言模型在推理、語言與創作上的能力快速提升，...",
    "publishDate": "2026-09-02",
    "excerpt": "從生物腦到數位腦， 人腦如何啟發人工智慧，人工智慧又如何推動神經科學研究？ 從人腦功能、神經表徵到深度學習與生成模型的跨領域解析 【從人腦到機器，重新追問智慧本質】 人類對智慧的探索，歷經萬物有靈、機械自動裝置、神經科學與人工智慧等不同階段。隨著大型語言模型在推理、語言與創作上的能力快速提升，智慧是否只是參數規模與運算能力的累積，成為當代科學的重要問題。本書指出，人類智慧並非單純取決於神經元數量，更涉及神經元之間的連結方式、訊息流動、功…"
  },
  {
    "id": "article-020",
    "slug": "monthly-recommendation-9786267165546",
    "title": "本日大唐速報！三十七位唐人的生活寫照：由初唐至晚唐，從黎明至黃昏，跟著唐人的一日行程，走進不同時代、不同身分的唐朝生活",
    "publisher": "崧博出版",
    "isbn": "9786267165546",
    "coverImage": "/assets/books/9786267165546.jpg",
    "category": "醫療保健",
    "tagline": "從宮門內的朝參，到市井裡的買賣 從科場上的等待，到邊城外的戰事 知名人物與無名小卒，各有不同的悲歡與命運 唐朝的制度、風俗與人情，就藏在尋常生活裡 ▎晨鐘暮鼓 本書從唐人的晨起、出門、赴宴、辦差與歸家寫起，跟著一日行程走入長安、幽州與各處邊鎮。民部尚書裴矩穿上朝服、攜魚符入宮，途中也不忘先到胡...",
    "publishDate": "2026-09-02",
    "excerpt": "從宮門內的朝參，到市井裡的買賣 從科場上的等待，到邊城外的戰事 知名人物與無名小卒，各有不同的悲歡與命運 唐朝的制度、風俗與人情，就藏在尋常生活裡 ▎晨鐘暮鼓 本書從唐人的晨起、出門、赴宴、辦差與歸家寫起，跟著一日行程走入長安、幽州與各處邊鎮。民部尚書裴矩穿上朝服、攜魚符入宮，途中也不忘先到胡食店吃一張胡餅；房玄齡的女兒隨母親赴相親之約，從梳妝、乘車到茶肆小聚，可見門第婚姻的考量與閨中女子的生活；李桂娘夫婦辦理和離，一紙夫妻相別書背後，…"
  },
  {
    "id": "article-021",
    "slug": "monthly-recommendation-9786269312887",
    "title": "股票作手李佛摩的交易心理學：看懂市場人性，避開散戶致命陷阱",
    "publisher": "策點文化",
    "isbn": "9786269312887",
    "coverImage": "/assets/books/9786269312887.jpg",
    "category": "商業理財",
    "tagline": "轉譯愛德溫．勒斐佛《股票作手回憶錄》 公式＋圖片＋表格，清楚看見每一次買賣的底層邏輯 FOMO追價×凹單攤平×報復性交易…… 看懂價格波動背後的人性反應 建立不被消息與熱門股牽著走的投資紀律！ 【從經典市場觀察，看見交易者自己】 本書以《股票作手回憶錄》為起點，將勒斐佛筆下的市場經驗整理成現代...",
    "publishDate": "2026-08-27",
    "excerpt": "轉譯愛德溫．勒斐佛《股票作手回憶錄》 公式＋圖片＋表格，清楚看見每一次買賣的底層邏輯 FOMO追價×凹單攤平×報復性交易…… 看懂價格波動背後的人性反應 建立不被消息與熱門股牽著走的投資紀律！ 【從經典市場觀察，看見交易者自己】 本書以《股票作手回憶錄》為起點，將勒斐佛筆下的市場經驗整理成現代投資人容易理解的交易心理入門。本書帶領讀者看見：每一次買進、賣出、等待與猶豫，背後都牽動人的期待、恐懼、貪婪與不甘心。股價變動只是表面，真正影響結…"
  },
  {
    "id": "article-022",
    "slug": "monthly-recommendation-9786264284325",
    "title": "句芒至年獸，從立春到大寒的二十四種奇談：倉頡造字、王冕畫荷、林教頭夜宿山神廟，二十四節氣裡不只神話，更有人間歷史",
    "publisher": "複刻文化",
    "isbn": "9786264284325",
    "coverImage": "/assets/books/9786264284325.jpg",
    "category": "醫療保健",
    "tagline": "為什麼立夏要「稱人」，冬至要吃「嬌耳」？ 倉頡造字與穀雨有關聯？一棵柿子樹竟也能被封侯？ 跟著節氣翻頁，用二十四篇故事走完一整年！ 【春生：從節氣認識四時】 本書從立春出發，依照二十四節氣的順序，介紹一年之中氣候、物候與生活方式的變化。每個節氣先說明名稱由來、三候特徵與相關習俗，再配合神話、歷...",
    "publishDate": "2026-08-26",
    "excerpt": "為什麼立夏要「稱人」，冬至要吃「嬌耳」？ 倉頡造字與穀雨有關聯？一棵柿子樹竟也能被封侯？ 跟著節氣翻頁，用二十四篇故事走完一整年！ 【春生：從節氣認識四時】 本書從立春出發，依照二十四節氣的順序，介紹一年之中氣候、物候與生活方式的變化。每個節氣先說明名稱由來、三候特徵與相關習俗，再配合神話、歷史人物或民間故事，使原本較為簡略的曆法知識有了具體內容。春季篇從草木萌發、雨水增多寫到晝夜平分與農事漸忙，並穿插句芒掌春、天穿日、介子推寒食節與倉…"
  },
  {
    "id": "article-023",
    "slug": "monthly-recommendation-9786267940075",
    "title": "晉商喬家何以興盛？從白手起家到富甲一方的經營智慧：靠手藝起家，以信用立足，憑人才拓展，一條由小生意走出的漫長商路",
    "publisher": "山頂視角",
    "isbn": "9786267940075",
    "coverImage": "/assets/books/9786267940075.jpg",
    "category": "商業理財",
    "tagline": "長袖善舞，多財善賈 濟弱扶傾，富而有仁 從微末起步，開創延續二百年的商業版圖 一個家族的興盛，靠的是眼光、制度與長遠布局 【從困境中突圍，在變局裡找到商機】 一個家族如何從微末起步，逐步建立橫跨多地、延續二百年的商業版圖？答案不只在於勤奮與節儉，更在於面對困局時勇於求變的眼光。本書以喬家商業發...",
    "publishDate": "2026-08-26",
    "excerpt": "長袖善舞，多財善賈 濟弱扶傾，富而有仁 從微末起步，開創延續二百年的商業版圖 一個家族的興盛，靠的是眼光、制度與長遠布局 【從困境中突圍，在變局裡找到商機】 一個家族如何從微末起步，逐步建立橫跨多地、延續二百年的商業版圖？答案不只在於勤奮與節儉，更在於面對困局時勇於求變的眼光。本書以喬家商業發展歷程為主軸，從擇業、擇地、技術與資源整合談起，說明喬家如何離開受限的環境，憑藉手藝累積第一桶金，再透過人才與資金的有效組合，在產業空缺中開創新局…"
  },
  {
    "id": "article-024",
    "slug": "monthly-recommendation-9786267866276",
    "title": "從粒子到生命的推導，薛丁格的遺傳物質推想：複製、排列、突變、更新……從遺傳資訊的保存到物質與能量的交換，說明生命持續存在的條件",
    "publisher": "沐燁文化",
    "isbn": "9786267866276",
    "coverImage": "/assets/books/9786267866276.jpg",
    "category": "醫療保健",
    "tagline": "微小的遺傳物質，如何把生命資訊一代代傳遞下去？ 生命為何能在持續變動之中，維持穩定與秩序？ 編譯自薛丁格《生命是什麼？》 一場從原子出發，通往生命本質的科學探索 【物理學如何追問生命】 生命身處充滿熱擾動與偶然碰撞的微觀世界，卻能長久維持精確而穩定的運作。本書從原子尺度、布朗運動、統計規律與精...",
    "publishDate": "2026-08-26",
    "excerpt": "微小的遺傳物質，如何把生命資訊一代代傳遞下去？ 生命為何能在持續變動之中，維持穩定與秩序？ 編譯自薛丁格《生命是什麼？》 一場從原子出發，通往生命本質的科學探索 【物理學如何追問生命】 生命身處充滿熱擾動與偶然碰撞的微觀世界，卻能長久維持精確而穩定的運作。本書從原子尺度、布朗運動、統計規律與精密機械談起，說明單一粒子的行蹤雖難以預測，大量粒子仍能形成可靠的宏觀現象。然而，遺傳與發育往往由極少量物質控制，無法完全依靠大數平均解釋。機械比喻…"
  },
  {
    "id": "article-025",
    "slug": "monthly-recommendation-9786269312863",
    "title": "「離線」焦慮，困在螢幕裡的多巴胺：演算法推播、碎片化學習、效率幻象、多巴胺成癮……在曝光與分享成為常態的時代，人如何在資訊洪流中逐漸模糊了個體價值？",
    "publisher": "策點文化",
    "isbn": "9786269312863",
    "coverImage": "/assets/books/9786269312863.jpg",
    "category": "商業理財",
    "tagline": "你也是被演算法控制的「多巴胺奴隸」嗎？ 按讚、追蹤、網路社交、成癮行為…… 當演算法與社群身分成為標籤，我們如何定義自己是誰？ ▎工具與思維：從尼采到網路時代的轉變 本書開篇指出工具不僅是人類思維的產物，也會反過來塑造人的思考方式。當代社會中，網路已成為最重要的工具之一，其影響遠超過過去的書寫...",
    "publishDate": "2026-08-20",
    "excerpt": "你也是被演算法控制的「多巴胺奴隸」嗎？ 按讚、追蹤、網路社交、成癮行為…… 當演算法與社群身分成為標籤，我們如何定義自己是誰？ ▎工具與思維：從尼采到網路時代的轉變 本書開篇指出工具不僅是人類思維的產物，也會反過來塑造人的思考方式。當代社會中，網路已成為最重要的工具之一，其影響遠超過過去的書寫技術。人們的行為模式逐漸轉向多工處理、碎片化注意與即時回饋，甚至在不知不覺中改變了價值觀與世界觀。作者強調，網路讓人建立虛擬自我、依賴即時資訊與社…"
  },
  {
    "id": "article-026",
    "slug": "monthly-recommendation-9786264284271",
    "title": "大明末世錄，荒唐忠奸十二臣：清官受謗、名將戰死、權臣誤國、降將開關……崇禎朝最後的歲月，十二位明末人物忠或奸的選擇",
    "publisher": "複刻文化",
    "isbn": "9786264284271",
    "coverImage": "/assets/books/9786264284271.jpg",
    "category": "商業理財",
    "tagline": "軍餉枯竭×精銳折損×天災流民×將相無能…… 從守城赴死到開關迎敵， 十二位明末人物的抉擇如何影響王朝的末路？ 【王朝末路，多重危機交會】 明朝自萬曆年間逐漸顯露衰象，至崇禎即位時，國家早已陷入內外交迫的困境。萬曆三大征雖取得軍事成果，卻耗費巨額軍餉，使國庫空虛，遼東鐵騎、戚家軍等精銳也在長期征...",
    "publishDate": "2026-08-19",
    "excerpt": "軍餉枯竭×精銳折損×天災流民×將相無能…… 從守城赴死到開關迎敵， 十二位明末人物的抉擇如何影響王朝的末路？ 【王朝末路，多重危機交會】 明朝自萬曆年間逐漸顯露衰象，至崇禎即位時，國家早已陷入內外交迫的困境。萬曆三大征雖取得軍事成果，卻耗費巨額軍餉，使國庫空虛，遼東鐵騎、戚家軍等精銳也在長期征戰中大量折損。其後，土地兼併加劇，皇室宗親與官紳設法逃避賦稅，國家收入日益減少；為填補軍費缺口，朝廷持續加派賦稅，又進一步加重百姓負擔。到了明末，…"
  },
  {
    "id": "article-027",
    "slug": "monthly-recommendation-9786267865835",
    "title": "西方女權思想家：從喬治．桑到西蒙．波娃，看見八位改變世界的女性如何活出自我",
    "publisher": "崧博出版",
    "isbn": "9786267865835",
    "coverImage": "/assets/books/9786267865835.jpg",
    "category": "科普知識",
    "tagline": "她們追求自由，卻不曾放棄愛； 她們反抗束縛，也擁抱慾望。 那些改變世界的女人， 又是如何活出自己的人生？ 【走在時代之前，她們為自由而生】 從法國大革命的吶喊到《第二性》的誕生，女權運動改變了世界對女性的想像，也讓無數女性開始思考何謂自由、何謂自我。本書以女權運動的發展為背景，帶領讀者走進八位...",
    "publishDate": "2026-08-19",
    "excerpt": "她們追求自由，卻不曾放棄愛； 她們反抗束縛，也擁抱慾望。 那些改變世界的女人， 又是如何活出自己的人生？ 【走在時代之前，她們為自由而生】 從法國大革命的吶喊到《第二性》的誕生，女權運動改變了世界對女性的想像，也讓無數女性開始思考何謂自由、何謂自我。本書以女權運動的發展為背景，帶領讀者走進八位西方傳奇女性的人生故事。她們是作家、藝術家，也是思想的先驅，在各自的時代裡打破傳統的框架，以獨特的生命姿態回應社會的期待與束縛。 【傳奇之外，她們…"
  },
  {
    "id": "article-028",
    "slug": "monthly-recommendation-9786267782576",
    "title": "你的薪資單，不代表你的資產總額：薪水進來，不一定都是你的！盤點現金、房產、ETF基金、保單與人力資本，打造能長期累積的資產系統",
    "publisher": "機曜文化",
    "isbn": "9786267782576",
    "coverImage": "/assets/books/9786267782576.jpg",
    "category": "醫療保健",
    "tagline": "【先看懂資產，才能真正累積財富】 建立資產管理能力，讓每一分收入成為未來的財富！ ▎先盤點自己真正擁有什麼 多數人每天關心薪水、存款與投資績效，卻很少真正整理自己的財務狀況。本書從資產、負債與淨資產三個基本概念出發，說明為什麼收入只是現金流，真正決定財務實力的是累積下來的資產。透過個人資產負債...",
    "publishDate": "2026-08-19",
    "excerpt": "【先看懂資產，才能真正累積財富】 建立資產管理能力，讓每一分收入成為未來的財富！ ▎先盤點自己真正擁有什麼 多數人每天關心薪水、存款與投資績效，卻很少真正整理自己的財務狀況。本書從資產、負債與淨資產三個基本概念出發，說明為什麼收入只是現金流，真正決定財務實力的是累積下來的資產。透過個人資產負債表、淨資產計算與資產地圖等工具，引導讀者重新盤點自己的財務位置，了解哪些是真正的資產，哪些只是持續消耗現金流的負擔，建立管理財富的第一步。 ▎重新…"
  },
  {
    "id": "article-029",
    "slug": "monthly-recommendation-9786269312870",
    "title": "基因圖鑑：長壽祕密×基因編輯×再生科技，生命如何無限延續？",
    "publisher": "策點文化",
    "isbn": "9786269312870",
    "coverImage": "/assets/books/9786269312870.jpg",
    "category": "醫療保健",
    "tagline": "基因像一座階梯，連接過去的演化與未來的科技 沿著生命的天梯向上，看見人類探索自身的漫長旅程 【從好奇出發，理解生命的第一步】 人類對生命的提問，往往始於最簡單的觀察：為什麼鳥的喙形各異？為什麼豌豆會呈現不同顏色與形狀？從這些看似平凡的現象出發，科學逐步揭開遺傳的規律，建立起理解生命的基礎。本書...",
    "publishDate": "2026-08-13",
    "excerpt": "基因像一座階梯，連接過去的演化與未來的科技 沿著生命的天梯向上，看見人類探索自身的漫長旅程 【從好奇出發，理解生命的第一步】 人類對生命的提問，往往始於最簡單的觀察：為什麼鳥的喙形各異？為什麼豌豆會呈現不同顏色與形狀？從這些看似平凡的現象出發，科學逐步揭開遺傳的規律，建立起理解生命的基礎。本書以輕鬆而富有畫面感的敘事，帶領讀者回到科學誕生的現場，透過達爾文、孟德爾與果蠅實驗等經典案例，重新看見基因如何在不被察覺的情況下，悄悄塑造萬物的樣…"
  },
  {
    "id": "article-030",
    "slug": "monthly-recommendation-9786264085281",
    "title": "誰替時間標上價格？龐巴維克的資本報酬追問：生產力學說×效用學說×勞動學說……梳理歷代利息爭論，理解不同時間的金錢為何不能等量交換",
    "publisher": "財經錢線",
    "isbn": "9786264085281",
    "coverImage": "/assets/books/9786264085281.jpg",
    "category": "醫療保健",
    "tagline": "編譯自龐巴維克《資本與利息》 追查資本報酬究竟從何而來 借款人用未來收入，換取今天的行動能力 投資人交出現在的資金，等待未來的回報 利息，正是不同時間點之間的交換條件 【錢一進入時間，為什麼就不一樣了】 房貸要付利息、刷卡分期有成本、存款和債券能帶來報酬，這些日常經驗都指向同一個問題：一筆錢交...",
    "publishDate": "2026-08-12",
    "excerpt": "編譯自龐巴維克《資本與利息》 追查資本報酬究竟從何而來 借款人用未來收入，換取今天的行動能力 投資人交出現在的資金，等待未來的回報 利息，正是不同時間點之間的交換條件 【錢一進入時間，為什麼就不一樣了】 房貸要付利息、刷卡分期有成本、存款和債券能帶來報酬，這些日常經驗都指向同一個問題：一筆錢交到別人手中，日後為什麼可以收回更多？本書先從利息的歷史談起。早期借貸多半用來度過飢荒、疾病與生活急難，向窮困者收取利息，常被視為趁人之危。後來商業…"
  },
  {
    "id": "article-031",
    "slug": "monthly-recommendation-9786267866245",
    "title": "墨跡──在字裡行間遇見名家：不只看懂書法，更讀懂筆墨背後的人與時代",
    "publisher": "沐燁文化",
    "isbn": "9786267866245",
    "coverImage": "/assets/books/9786267866245.jpg",
    "category": "歷史",
    "tagline": "當真跡走出展櫃，歷史便在字裡行間鮮活起來！ 【從博物館出發，重返文化現場】 當我們走進博物館，凝視一幅古畫、一方碑刻或一件書法真跡時，看見的往往不只是文物本身，更是一段被時光封存的歷史。本書以博物館館藏為依託，帶領讀者穿梭於傳統文化的長河之中，從一件件珍貴文物出發，重新認識那些影響千年文明的文...",
    "publishDate": "2026-08-12",
    "excerpt": "當真跡走出展櫃，歷史便在字裡行間鮮活起來！ 【從博物館出發，重返文化現場】 當我們走進博物館，凝視一幅古畫、一方碑刻或一件書法真跡時，看見的往往不只是文物本身，更是一段被時光封存的歷史。本書以博物館館藏為依託，帶領讀者穿梭於傳統文化的長河之中，從一件件珍貴文物出發，重新認識那些影響千年文明的文化巨匠。 【名家身影背後，不為人知的人生故事】 書中選取秦漢至近代數十位具有代表性的文化名家，包括王維、韓愈、柳宗元、曾鞏、黃庭堅、王冕等歷史人物…"
  },
  {
    "id": "article-032",
    "slug": "monthly-recommendation-9786267940068",
    "title": "兩千年未解的權力死局：封建、郡縣、削藩與集權背後的制度邏輯",
    "publisher": "山頂視角",
    "isbn": "9786267940068",
    "coverImage": "/assets/books/9786267940068.jpg",
    "category": "心理學",
    "tagline": "「姓」與「氏」的關係與演變為何？ 「封建制」和「郡縣制」究竟哪個更好？ 此消彼長的政治角力，如何造成歷史的輪迴？ 推恩令×削藩政策×郡國並行制…… 修補舊弊卻又養出新患，治世與亂世循環的制度根源 【李約瑟難題】 本書開篇先從近代以來反覆被提出的「李約瑟難題」談起：中國古代曾長期在技術與文明發展...",
    "publishDate": "2026-08-12",
    "excerpt": "「姓」與「氏」的關係與演變為何？ 「封建制」和「郡縣制」究竟哪個更好？ 此消彼長的政治角力，如何造成歷史的輪迴？ 推恩令×削藩政策×郡國並行制…… 修補舊弊卻又養出新患，治世與亂世循環的制度根源 【李約瑟難題】 本書開篇先從近代以來反覆被提出的「李約瑟難題」談起：中國古代曾長期在技術與文明發展上走在世界前列，為何到了近代，卻沒能順勢走出科學革命與工業革命的道路？作者並不滿足於地理條件、文化性格或民族思維這類習見說法，而是一步步把問題引回…"
  },
  {
    "id": "article-033",
    "slug": "monthly-recommendation-9786269312856",
    "title": "讓步之前，先看穿再談判：可以談條件的人很多，會打心理戰才能占上風",
    "publisher": "策點文化",
    "isbn": "9786269312856",
    "coverImage": "/assets/books/9786269312856.jpg",
    "category": "心理學",
    "tagline": "真正厲害的談判者，先讀空氣，再談利益 一句話怎麼說，往往比說了什麼更關鍵 ▎在交涉裡，看見人心的運作 談判常被想像成商場上的攻防、會議桌前的角力，甚至是高手之間的語言博弈；其實，它更深的核心，是對人性、情緒、需求與判斷機制的理解。無論是工作協商、價格磋商、職場溝通，還是日常關係中的意見交換，人...",
    "publishDate": "2026-08-06",
    "excerpt": "真正厲害的談判者，先讀空氣，再談利益 一句話怎麼說，往往比說了什麼更關鍵 ▎在交涉裡，看見人心的運作 談判常被想像成商場上的攻防、會議桌前的角力，甚至是高手之間的語言博弈；其實，它更深的核心，是對人性、情緒、需求與判斷機制的理解。無論是工作協商、價格磋商、職場溝通，還是日常關係中的意見交換，人與人之間每一次試圖說服、爭取、退讓、平衡的過程，都隱含著談判的結構。真正左右結果的，往往不是話說得多漂亮，而是能不能看懂對方在意什麼、自己又該守住…"
  },
  {
    "id": "article-034",
    "slug": "monthly-recommendation-9786264169875",
    "title": "細胞演化簡史，從能量到免疫系統：RNA拓荒、DNA登場、膜形成邊界、粒線體加入分工……從生命起源到癌症、免疫與人工智慧，重看細胞如何組成我們所知的生命",
    "publisher": "崧燁文化",
    "isbn": "9786264169875",
    "coverImage": "/assets/books/9786264169875.jpg",
    "category": "醫療保健",
    "tagline": "細胞如何演化成生命？ 訊息傳遞×能量驅動×基因表達×免疫防線…… 從RNA、DNA到細胞器與多細胞生命， 以演化為線索，讀懂細胞從分子到生命共同體的完整旅程 【以邏輯重新理解細胞】 本書是一部以細胞生物學為核心的科普作品，作者從醫學院校教學經驗出發，回應學生常感到細胞生物學「難學、散亂、缺少邏...",
    "publishDate": "2026-08-05",
    "excerpt": "細胞如何演化成生命？ 訊息傳遞×能量驅動×基因表達×免疫防線…… 從RNA、DNA到細胞器與多細胞生命， 以演化為線索，讀懂細胞從分子到生命共同體的完整旅程 【以邏輯重新理解細胞】 本書是一部以細胞生物學為核心的科普作品，作者從醫學院校教學經驗出發，回應學生常感到細胞生物學「難學、散亂、缺少邏輯」的困惑。全書並不以傳統教材常見的「由外而內、由結構到功能」方式鋪陳，而是試圖從生命演化的脈絡中，找出細胞運作背後的基本邏輯。作者將「效率」與「…"
  },
  {
    "id": "article-035",
    "slug": "monthly-recommendation-9786264085212",
    "title": "看懂股市，不被行情牽著走：給普通人的圖解投資理財課",
    "publisher": "財經錢線",
    "isbn": "9786264085212",
    "coverImage": "/assets/books/9786264085212.jpg",
    "category": "商業理財",
    "tagline": "【投資是一套判斷系統，而非猜漲跌的遊戲】 寫給普通人的股票投資入門書── 先避開大錯，再建立能長期執行的投資判斷系統！ ▎建立正確的投資觀念 本書從一般投資人最容易產生的迷思切入，說明股市並非賭場，也不是快速致富的工具，而是評估企業價值與市場價格的場所。作者引導讀者重新認識股票的本質，理解買進...",
    "publishDate": "2026-08-05",
    "excerpt": "【投資是一套判斷系統，而非猜漲跌的遊戲】 寫給普通人的股票投資入門書── 先避開大錯，再建立能長期執行的投資判斷系統！ ▎建立正確的投資觀念 本書從一般投資人最容易產生的迷思切入，說明股市並非賭場，也不是快速致富的工具，而是評估企業價值與市場價格的場所。作者引導讀者重新認識股票的本質，理解買進股票代表持有一家企業未來創造價值的能力，而非單純追逐價格波動。透過價值、價格與情緒三個面向，協助讀者建立理性的投資觀念，避免受到市場消息、熱門話題…"
  },
  {
    "id": "article-036",
    "slug": "monthly-recommendation-9786267866238",
    "title": "鐫影──從碑刻拓本看歷史：文物如何成為歷史的載體，在歲月流轉中保存文明的記憶與時代的痕跡？",
    "publisher": "沐燁文化",
    "isbn": "9786267866238",
    "coverImage": "/assets/books/9786267866238.jpg",
    "category": "科普知識",
    "tagline": "碑石無言，卻記得山河更迭； 墨影不語，卻收藏人世悲歡。 【山河有盡，碑石長存】 歷史並不只存在於史書之中。有時候，一塊殘碑、一紙拓本、一方刻石，反而比文字記載保留了更多時代的痕跡。本書以博物館珍藏的金石碑刻、拓本墨影與歷史文物為起點，帶領讀者走入橫跨兩千餘年的文化現場。從秦始皇東巡刻石到晚清文...",
    "publishDate": "2026-08-05",
    "excerpt": "碑石無言，卻記得山河更迭； 墨影不語，卻收藏人世悲歡。 【山河有盡，碑石長存】 歷史並不只存在於史書之中。有時候，一塊殘碑、一紙拓本、一方刻石，反而比文字記載保留了更多時代的痕跡。本書以博物館珍藏的金石碑刻、拓本墨影與歷史文物為起點，帶領讀者走入橫跨兩千餘年的文化現場。從秦始皇東巡刻石到晚清文人的碑學收藏，作者循著文物留下的線索，重新追索那些影響中國歷史的重要人物與事件。每一件館藏都不只是靜止的展品，而是一段仍在訴說的歷史。 【一紙拓本…"
  },
  {
    "id": "article-037",
    "slug": "monthly-recommendation-9786269312832",
    "title": "從來沒有天賦優越，18位知名科學家的學習思維：笛卡爾、達爾文、愛因斯坦……你也可以培養出屬於自己的天才思考",
    "publisher": "策點文化",
    "isbn": "9786269312832",
    "coverImage": "/assets/books/9786269312832.jpg",
    "category": "心理學",
    "tagline": "天才不是天生，而是一步步被「設計」出來的思考方式 從愛因斯坦到費曼，看見真正拉開差距的學習關鍵 ▎在天才之外，看見可複製的學習路徑 人們習慣將偉大科學家的成就歸因於天賦，卻忽略了其背後可被理解、甚至可被借鑑的學習模式。本書從多位重量級科學家的成長軌跡出發，試圖回答一個更實際的問題：卓越是否真的...",
    "publishDate": "2026-07-30",
    "excerpt": "天才不是天生，而是一步步被「設計」出來的思考方式 從愛因斯坦到費曼，看見真正拉開差距的學習關鍵 ▎在天才之外，看見可複製的學習路徑 人們習慣將偉大科學家的成就歸因於天賦，卻忽略了其背後可被理解、甚至可被借鑑的學習模式。本書從多位重量級科學家的成長軌跡出發，試圖回答一個更實際的問題：卓越是否真的只屬於少數人，還是其實有跡可循？透過重建他們在關鍵時刻的選擇與思考，讀者將逐步理解，所謂「天才」，往往建立在長期累積的學習策略與環境互動之上。 ▎…"
  },
  {
    "id": "article-038",
    "slug": "monthly-recommendation-9786264284141",
    "title": "古人的執念，藏在名篇裡：從〈醉翁亭記〉、〈岳陽樓記〉到〈湖心亭看雪〉，讀懂二十位文豪的人生與成敗",
    "publisher": "複刻文化",
    "isbn": "9786264284141",
    "coverImage": "/assets/books/9786264284141.jpg",
    "category": "科普知識",
    "tagline": "一首詩、一篇文、一段掌故，藏著一個人最深的執念 沿著古人的命運轉折，讀出文學背後的孤獨、堅持與未竟之志 ▎從名篇與人物，走進古典文學的生命現場 古典文學最迷人的地方，往往不只在名句本身，更在於文字背後那個活生生的人。項羽為何走向烏江之敗？諸葛亮如何面對繼承與權力的迷霧？曹操北征烏桓，藏著怎樣的...",
    "publishDate": "2026-07-29",
    "excerpt": "一首詩、一篇文、一段掌故，藏著一個人最深的執念 沿著古人的命運轉折，讀出文學背後的孤獨、堅持與未竟之志 ▎從名篇與人物，走進古典文學的生命現場 古典文學最迷人的地方，往往不只在名句本身，更在於文字背後那個活生生的人。項羽為何走向烏江之敗？諸葛亮如何面對繼承與權力的迷霧？曹操北征烏桓，藏著怎樣的九死一生？李煜亡國之後，故國又如何成為心中永遠回不去的歸處？本書以二十位歷史與文學人物為核心，從家國、事業、知己、家庭、居所五個方向切入，將詩詞文…"
  },
  {
    "id": "article-039",
    "slug": "monthly-recommendation-9786264085144",
    "title": "金錢時間差，可惡！帳單總比收入先一步抵達：信用卡、分期付款、先買後付……你缺的不是更多收入，而是讓錢在正確時間解決問題的能力！",
    "publisher": "財經錢線",
    "isbn": "9786264085144",
    "coverImage": "/assets/books/9786264085144.jpg",
    "category": "醫療保健",
    "tagline": "Ⓞ錢變多，不代表生活就有底氣 Ⓞ收入提高，不代表財務就有空間 Ⓞ分期降低眼前壓力，也可能提前占用未來 從薪水、帳單、分期到現金流 揭開收入提高卻越來越沒安全感的真相 【從生活重新理解金融】 金融並不是離日常很遠的專業語言，也不只是股票、基金、貸款與利率公式。本書從最基本的問題出發：為什麼今天的...",
    "publishDate": "2026-07-29",
    "excerpt": "Ⓞ錢變多，不代表生活就有底氣 Ⓞ收入提高，不代表財務就有空間 Ⓞ分期降低眼前壓力，也可能提前占用未來 從薪水、帳單、分期到現金流 揭開收入提高卻越來越沒安全感的真相 【從生活重新理解金融】 金融並不是離日常很遠的專業語言，也不只是股票、基金、貸款與利率公式。本書從最基本的問題出發：為什麼今天的一萬元，和十年後的一萬元並不相同？當時間被放進金錢判斷裡，便當價格、房租、薪資、退休金、分期付款與信用卡帳單，都不再只是單純的數字，而是牽涉購買力…"
  },
  {
    "id": "article-040",
    "slug": "monthly-recommendation-9786267866207",
    "title": "色境──畫作中的名家：一件文物，一段人生；一座博物館，一部文明史！",
    "publisher": "沐燁文化",
    "isbn": "9786267866207",
    "coverImage": "/assets/books/9786267866207.jpg",
    "category": "歷史",
    "tagline": "走進博物館，看見的不只是文物，還有千年文化的靈魂！ 【從博物館出發，重返文化現場】 當我們走進博物館，凝視一幅古畫、一方碑刻或一件書法真跡時，看見的往往不只是文物本身，更是一段被時光封存的歷史。本書以博物館館藏為依託，帶領讀者穿梭於傳統文化的長河之中，從一件件珍貴文物出發，重新認識那些影響千年...",
    "publishDate": "2026-07-29",
    "excerpt": "走進博物館，看見的不只是文物，還有千年文化的靈魂！ 【從博物館出發，重返文化現場】 當我們走進博物館，凝視一幅古畫、一方碑刻或一件書法真跡時，看見的往往不只是文物本身，更是一段被時光封存的歷史。本書以博物館館藏為依託，帶領讀者穿梭於傳統文化的長河之中，從一件件珍貴文物出發，重新認識那些影響千年文明的文化巨匠。 【名家身影背後，不為人知的人生故事】 書中選取秦漢至近代數十位具有代表性的文化名家，包括王維、韓愈、柳宗元、曾鞏、黃庭堅、王冕等…"
  },
  {
    "id": "article-041",
    "slug": "monthly-recommendation-9786269312849",
    "title": "綠茶，懂喝從這一杯開始：茶葉分類×名茶巡禮×文化欣賞，以生活化的角度，讀懂綠茶的知識與趣味",
    "publisher": "策點文化",
    "isbn": "9786269312849",
    "coverImage": "/assets/books/9786269312849.jpg",
    "category": "歷史",
    "tagline": "一盞綠意入喉，喝下的是清香，讀見的卻是千年茶史與山水風土 從茶樹、茶藝到茶道精神，展開綠茶世界的深厚樣貌 ▎從一片葉子，看見文明的長成 綠茶之所以動人，從來不只在清香入口的瞬間，更在於它背後綿延千年的文化累積。這部作品以綠茶為軸，回望茶從遠古採食、羹飲萌芽，到隋唐普及、宋元風雅，再到明清清飲成...",
    "publishDate": "2026-07-23",
    "excerpt": "一盞綠意入喉，喝下的是清香，讀見的卻是千年茶史與山水風土 從茶樹、茶藝到茶道精神，展開綠茶世界的深厚樣貌 ▎從一片葉子，看見文明的長成 綠茶之所以動人，從來不只在清香入口的瞬間，更在於它背後綿延千年的文化累積。這部作品以綠茶為軸，回望茶從遠古採食、羹飲萌芽，到隋唐普及、宋元風雅，再到明清清飲成熟與當代走向世界的歷程，勾勒出一條與華人生活、審美與精神史緊密交纏的文化長線。茶在這裡不是單純飲品，而是一種日常實踐，也是一種文明記憶，承載了人們…"
  },
  {
    "id": "article-042",
    "slug": "monthly-recommendation-9786264169783",
    "title": "書影千年，從《山海經》到《紅樓夢》：紙墨裝幀×版刻圖像×典籍掌故×版本源流……從古典神話至明清小說，在書頁之間看見中華文化的流轉與風雅",
    "publisher": "崧燁文化",
    "isbn": "9786264169783",
    "coverImage": "/assets/books/9786264169783.jpg",
    "category": "心理學",
    "tagline": "遞藏源流、文人雅趣、審美思辨、紙墨情懷 以書話筆法品讀典籍珍本， 在紙墨遞藏間發現中國傳統文化的幽微與壯闊 【古籍傳承：從書厄到紙壽千年】 本書是一部以中國古典文獻為核心的閱讀隨筆集。作者白羽從古籍流傳的艱難寫起，回望抄本時代、印本時代與歷代藏書災厄，指出今日仍能見到唐寫本、宋元明清刻本、套印...",
    "publishDate": "2026-07-22",
    "excerpt": "遞藏源流、文人雅趣、審美思辨、紙墨情懷 以書話筆法品讀典籍珍本， 在紙墨遞藏間發現中國傳統文化的幽微與壯闊 【古籍傳承：從書厄到紙壽千年】 本書是一部以中國古典文獻為核心的閱讀隨筆集。作者白羽從古籍流傳的艱難寫起，回望抄本時代、印本時代與歷代藏書災厄，指出今日仍能見到唐寫本、宋元明清刻本、套印本、活字本等文獻，是歷史偶然與人力守護共同留下的結果。全書不單介紹古書內容，也重視版本、紙墨、版刻、題跋、藏印與裝幀，將古籍視為承載文明記憶的實物…"
  },
  {
    "id": "article-043",
    "slug": "monthly-recommendation-9786264169776",
    "title": "走路痛得要死！從病因看懂膝蓋痛：腰椎神經×微循環×免疫代謝×關節損傷，從多重病因解析膝骨關節炎",
    "publisher": "崧燁文化",
    "isbn": "9786264169776",
    "coverImage": "/assets/books/9786264169776.jpg",
    "category": "醫療保健",
    "tagline": "膝關節退化不是單一磨損 而是多重因素共同發出的警訊 膝蓋痛只能忍？從病因找回行走自由 找不到膝痛根源？先從神經、微循環與代謝開始追查 從腰椎神經到免疫代謝，從關節損傷到全身疾病 ──重新看懂膝骨關節炎，找到治療的新方向！ ▎膝蓋痛，真的只是老化嗎？ 膝骨關節炎是許多中老年人熟悉卻又難以真正理解...",
    "publishDate": "2026-07-22",
    "excerpt": "膝關節退化不是單一磨損 而是多重因素共同發出的警訊 膝蓋痛只能忍？從病因找回行走自由 找不到膝痛根源？先從神經、微循環與代謝開始追查 從腰椎神經到免疫代謝，從關節損傷到全身疾病 ──重新看懂膝骨關節炎，找到治療的新方向！ ▎膝蓋痛，真的只是老化嗎？ 膝骨關節炎是許多中老年人熟悉卻又難以真正理解的疾病。疼痛、腫脹、僵硬、上下樓困難、行走受限，往往被簡單歸因於「年紀大了」、「關節磨損了」或「體重太重」。然而，本書作者認為膝骨關節炎並不是單純…"
  },
  {
    "id": "article-044",
    "slug": "monthly-recommendation-9786267782545",
    "title": "AIGC浪潮，人人都可以成為創作高手：顛覆創作思維！從提示詞到文本、影像、影音的內容生成，活用ChatGPT與Midjourney拓展視覺發展",
    "publisher": "機曜文化",
    "isbn": "9786267782545",
    "coverImage": "/assets/books/9786267782545.jpg",
    "category": "AIGC 書籍",
    "tagline": "生成式AI正在改變創作方式與工作流程 看懂它的原理、工具應用與產業變化 掌握人機協作的關鍵能力，迎向智慧新時代 【理解技術，不被名詞嚇退】 本書適合想認識AIGC，卻不想一開始就陷入艱深術語的讀者。內容從人工智慧的起源、發展浪潮談起，說明鑑別式AI與生成式AI的差異，也帶出文字、影像、音樂、影...",
    "publishDate": "2026-07-22",
    "excerpt": "生成式AI正在改變創作方式與工作流程 看懂它的原理、工具應用與產業變化 掌握人機協作的關鍵能力，迎向智慧新時代 【理解技術，不被名詞嚇退】 本書適合想認識AIGC，卻不想一開始就陷入艱深術語的讀者。內容從人工智慧的起源、發展浪潮談起，說明鑑別式AI與生成式AI的差異，也帶出文字、影像、音樂、影片等內容生成能力如何逐步成熟。作者用生活化的例子解釋機器學習、GPT模型、Transformer與注意力機制等，讓看似遙遠的技術變得容易理解。讀者…"
  },
  {
    "id": "article-045",
    "slug": "monthly-recommendation-9786269312801",
    "title": "波動有規律，散戶也能看懂的艾略特理論操盤法：看懂集體行為規律，預測每次市場大循環",
    "publisher": "策點文化",
    "isbn": "9786269312801",
    "coverImage": "/assets/books/9786269312801.jpg",
    "category": "商業理財",
    "tagline": "單一指標老是失真？看著雜亂無章的K線只能乾著急？別迷失於繁複細節，掌握市場規律才能建立雙重保險褪去無效指標，你的投資書架就差這最後一本！ ▎回到艾略特思想原點 本書並不是一本單純介紹技術分析技巧的投資書，而是艾略特晚年重新整理自身理論後的重要著作。作者認為，過度細分的技術分析容易造成「千人千浪...",
    "publishDate": "2026-07-16",
    "excerpt": "單一指標老是失真？看著雜亂無章的K線只能乾著急？別迷失於繁複細節，掌握市場規律才能建立雙重保險褪去無效指標，你的投資書架就差這最後一本！ ▎回到艾略特思想原點 本書並不是一本單純介紹技術分析技巧的投資書，而是艾略特晚年重新整理自身理論後的重要著作。作者認為，過度細分的技術分析容易造成「千人千浪」的現象，使投資者迷失在複雜的數浪細節中，因此他重新回到波浪理論最初的核心目的──幫助投資者理解市場循環，並在市場中獲利。 ▎從自然法則理解市場循…"
  },
  {
    "id": "article-046",
    "slug": "monthly-recommendation-9786264284066",
    "title": "筆下留名，史記列傳英雄誌：忠臣名將×謀士辯才×隱逸智者×遊方醫家……透過三十位經典人物的命運起伏，進入司馬遷筆下的歷史現場與人性世界",
    "publisher": "複刻文化",
    "isbn": "9786264284066",
    "coverImage": "/assets/books/9786264284066.jpg",
    "category": "醫療保健",
    "tagline": "風雲人物皆入史，史記列傳群像！ 治國賢相、兵家名將、縱橫策士、失意英雄…… 讀見《史記》如何以細節、對話與命運轉折刻畫不朽人物 【以人物照見歷史】 本書以《史記》人物傳記為核心，從司馬遷「以人寫史」的精神出發，精選管仲、老子、孫武、蘇秦、魏無忌、廉頗藺相如、田單、屈原、李斯、韓信、叔孫通、張釋...",
    "publishDate": "2026-07-15",
    "excerpt": "風雲人物皆入史，史記列傳群像！ 治國賢相、兵家名將、縱橫策士、失意英雄…… 讀見《史記》如何以細節、對話與命運轉折刻畫不朽人物 【以人物照見歷史】 本書以《史記》人物傳記為核心，從司馬遷「以人寫史」的精神出發，精選管仲、老子、孫武、蘇秦、魏無忌、廉頗藺相如、田單、屈原、李斯、韓信、叔孫通、張釋之、扁鵲、李廣等人物篇章。全書不只是敘述古代人物事蹟，也透過人物命運呈現春秋戰國至秦漢之際的政治變動、思想流派、軍事謀略與人性抉擇。讀者可以從一篇…"
  },
  {
    "id": "article-047",
    "slug": "monthly-recommendation-9786264085076",
    "title": "金融泡沫的底層邏輯，約翰．勞與密西西比狂熱：發行準備金×銀行券流通，對股票的期望大於價值，信用從交易工具變成投機燃料",
    "publisher": "財經錢線",
    "isbn": "9786264085076",
    "coverImage": "/assets/books/9786264085076.jpg",
    "category": "商業理財",
    "tagline": "Ⓞ需求存在，不代表買賣一定成交 Ⓞ錢不只是財富，而是一套交易秩序 Ⓞ信用能讓市場加速，也可能讓風險擴散 真正重要的不是貨幣形式有多創新 而是承諾背後有沒有足夠的兌現能力 【重新讀懂約翰．勞的貨幣問題】 本書以約翰．勞《貨幣與貿易論》的貨幣思想為核心，從硬幣、白銀、紙幣、銀行、土地、國債與密西西...",
    "publishDate": "2026-07-15",
    "excerpt": "Ⓞ需求存在，不代表買賣一定成交 Ⓞ錢不只是財富，而是一套交易秩序 Ⓞ信用能讓市場加速，也可能讓風險擴散 真正重要的不是貨幣形式有多創新 而是承諾背後有沒有足夠的兌現能力 【重新讀懂約翰．勞的貨幣問題】 本書以約翰．勞《貨幣與貿易論》的貨幣思想為核心，從硬幣、白銀、紙幣、銀行、土地、國債與密西西比泡沫出發，重新追問金錢為何能被市場接受。約翰．勞關心的不是錢本身有多珍貴，而是貨幣如何讓陌生人之間完成計價、支付與交換。當一枚硬幣、一張紙幣或一…"
  },
  {
    "id": "article-048",
    "slug": "monthly-recommendation-9786264540131",
    "title": "冷詞熱讀，生僻詞裡的古今人情：酺醵×僦居×契愛×軫悼……從經史子集走向鄉鎮飯桌，在詞語的本義與流變中，重讀中華文化的精神根柢",
    "publisher": "樂律文化",
    "isbn": "9786264540131",
    "coverImage": "/assets/books/9786264540131.jpg",
    "category": "醫療保健",
    "tagline": "從歷史到現代，從群體到個人 每個生僻詞都承載著一段屬於它的文化 有些詞蘊含古人的制度與禮法 有些詞留有飯桌上的酒氣與人情 字裡行間，照見古今相通的人間故事 【從生僻詞進入漢語深處】 本書收錄108個今日較少使用、卻曾活躍於古籍文獻與文化生活中的詞語。作者逐一標示讀音，說明字義來源，再追索它們在...",
    "publishDate": "2026-07-15",
    "excerpt": "從歷史到現代，從群體到個人 每個生僻詞都承載著一段屬於它的文化 有些詞蘊含古人的制度與禮法 有些詞留有飯桌上的酒氣與人情 字裡行間，照見古今相通的人間故事 【從生僻詞進入漢語深處】 本書收錄108個今日較少使用、卻曾活躍於古籍文獻與文化生活中的詞語。作者逐一標示讀音，說明字義來源，再追索它們在詩文、史書、小說、筆記中的用法。這些詞是通往古典世界的入口。全書從詞義出發，慢慢牽出制度、思想、文學與社會風俗，使讀者明白：一個詞的生命，往往比想…"
  },
  {
    "id": "article-049",
    "slug": "monthly-recommendation-9786269312818",
    "title": "電子科學簡史，從雨天風箏到半導體的故事：量子霍爾效應×拓撲絕緣體×高溫超導……點亮數位文明的奈米閃光",
    "publisher": "策點文化",
    "isbn": "9786269312818",
    "coverImage": "/assets/books/9786269312818.jpg",
    "category": "心理學",
    "tagline": "法拉第與戴維，特斯拉與愛迪生 偉大的科學家有什麼愛恨情仇？ 他們的發現與發明又是如何改變世界？ 在背公式之前，讓我們先看幾個故事…… ▎從過去到未來 本書從電與半導體的早期發現出發，系統性梳理電晶體、集成電路等關鍵技術的誕生歷程，並一路延伸至自旋電子學、奈米技術、量子霍爾效應與拓撲絕緣體等尖端...",
    "publishDate": "2026-07-09",
    "excerpt": "法拉第與戴維，特斯拉與愛迪生 偉大的科學家有什麼愛恨情仇？ 他們的發現與發明又是如何改變世界？ 在背公式之前，讓我們先看幾個故事…… ▎從過去到未來 本書從電與半導體的早期發現出發，系統性梳理電晶體、集成電路等關鍵技術的誕生歷程，並一路延伸至自旋電子學、奈米技術、量子霍爾效應與拓撲絕緣體等尖端領域。全書時間跨度長、內容覆蓋廣，將兩百多年來電子技術與物理學的演進脈絡清晰串聯，使讀者能理解現代科技的來龍去脈，建立完整而連貫的知識框架。 ▎理…"
  },
  {
    "id": "article-050",
    "slug": "monthly-recommendation-9786264085038",
    "title": "努力被房價收走，亨利．喬治論進步與貧困：土地壟斷×租金上升×世代門檻，破解越勤奮越難安身的城市困局",
    "publisher": "財經錢線",
    "isbn": "9786264085038",
    "coverImage": "/assets/books/9786264085038.jpg",
    "category": "醫療保健",
    "tagline": "誰買不起房？誰承擔了進步的成本？誰取得了土地增值？ Ⓞ社會一邊展現繁榮，一邊製造壓力 Ⓞ收入進來以前，支出早就在排隊中 Ⓞ每一筆都合理，加起來卻讓人窒息 真正重要的不是城市有沒有進步 而是成果有沒有回到多數人的生活裡 【重新讀懂亨利．喬治的核心問題】 本書以亨利．喬治《進步與貧困》的土地思想為...",
    "publishDate": "2026-07-08",
    "excerpt": "誰買不起房？誰承擔了進步的成本？誰取得了土地增值？ Ⓞ社會一邊展現繁榮，一邊製造壓力 Ⓞ收入進來以前，支出早就在排隊中 Ⓞ每一筆都合理，加起來卻讓人窒息 真正重要的不是城市有沒有進步 而是成果有沒有回到多數人的生活裡 【重新讀懂亨利．喬治的核心問題】 本書以亨利．喬治《進步與貧困》的土地思想為核心，把十九世紀工業化、城市擴張與土地投機的經典提問，放回今日臺灣的房價、租金、通勤、社會住宅與公共建設現場。亨利．喬治關心的不是反對進步，而是追…"
  },
  {
    "id": "article-051",
    "slug": "monthly-recommendation-9786267940013",
    "title": "非對稱戰爭，衝突中的小國決策：以弱抗強的戰爭抉擇？從伊拉克、摩爾多瓦到塞爾維亞，解析後冷戰時代非對稱衝突的政治邏輯",
    "publisher": "山頂視角",
    "isbn": "9786267940013",
    "coverImage": "/assets/books/9786267940013.jpg",
    "category": "心理學",
    "tagline": "小國為何拒絕屈從強權？ 在戰敗風險中尋求政治生存 政權存續、國際支援、機會窗口…… 後冷戰時代小國與非國家政治實體挑戰強權的理論與案例分析 【研究核心】 本書聚焦後冷戰時代常規非對稱衝突，試圖回答一個看似矛盾的問題：為何小國或非國家政治實體，明知實力遠遜於大國，仍會選擇軍事對抗？作者馬林科．博...",
    "publishDate": "2026-07-08",
    "excerpt": "小國為何拒絕屈從強權？ 在戰敗風險中尋求政治生存 政權存續、國際支援、機會窗口…… 後冷戰時代小國與非國家政治實體挑戰強權的理論與案例分析 【研究核心】 本書聚焦後冷戰時代常規非對稱衝突，試圖回答一個看似矛盾的問題：為何小國或非國家政治實體，明知實力遠遜於大國，仍會選擇軍事對抗？作者馬林科．博比奇指出，傳統國際關係研究多從大國視角理解戰爭，容易忽略弱勢一方的決策邏輯。本書因此轉向小國決策層的處境，分析其如何在政權存續、領土完整、國內壓力…"
  },
  {
    "id": "article-052",
    "slug": "monthly-recommendation-9786267165492",
    "title": "AIGC互動設計實戰課：產品場景觀察×Midjourney生圖操作×介面視覺整合……建立從設計判斷到成稿製作的AIGC工作流程",
    "publisher": "清文華泉",
    "isbn": "9786267165492",
    "coverImage": "/assets/books/9786267165492.jpg",
    "category": "商業理財",
    "tagline": "│設計不怕從零開始，怕的是靈感無從找起！ │讓AI參與設計流程，看見更多可能性！ 解析風格×判斷需求×優化素材…… 讓視覺回應操作情境，打造更貼近使用者的互動體驗 【從產品場景切入AI介面設計】 本書以行動應用程式的實際設計情境為主軸，從社群、通訊、交友、音樂、短影片、生活服務、出行、金融理財...",
    "publishDate": "2026-07-08",
    "excerpt": "│設計不怕從零開始，怕的是靈感無從找起！ │讓AI參與設計流程，看見更多可能性！ 解析風格×判斷需求×優化素材…… 讓視覺回應操作情境，打造更貼近使用者的互動體驗 【從產品場景切入AI介面設計】 本書以行動應用程式的實際設計情境為主軸，從社群、通訊、交友、音樂、短影片、生活服務、出行、金融理財到知識分享等常見產品類型展開，帶領讀者觀察不同平臺的功能定位、使用者需求與視覺語言。書中從各類行動應用的實際設計任務展開，將首頁卡片、活動彈窗、會…"
  },
  {
    "id": "article-053",
    "slug": "monthly-recommendation-9786269312825",
    "title": "贏在轉折前，散戶也能看懂的江恩理論操盤法：看懂角度線與成交量密碼，你也能在趨勢反轉前冷靜布局",
    "publisher": "策點文化",
    "isbn": "9786269312825",
    "coverImage": "/assets/books/9786269312825.jpg",
    "category": "商業理財",
    "tagline": "老是買在山頂、賣在低谷？ 別再靠感覺畫趨勢線！ 快告別隨機盲目，建立進階交易邏輯！ ▎破解江恩時空理論的核心架構 本書深入整理江恩時空理論的重要內容，從時間循環、價格波動到成交量分析，完整說明市場運行背後的數學與幾何邏輯。書中認為，股市並非隨機波動，而是遵循特定循環與自然法則運行，因此透過時間...",
    "publishDate": "2026-07-02",
    "excerpt": "老是買在山頂、賣在低谷？ 別再靠感覺畫趨勢線！ 快告別隨機盲目，建立進階交易邏輯！ ▎破解江恩時空理論的核心架構 本書深入整理江恩時空理論的重要內容，從時間循環、價格波動到成交量分析，完整說明市場運行背後的數學與幾何邏輯。書中認為，股市並非隨機波動，而是遵循特定循環與自然法則運行，因此透過時間、空間與價格之間的關係，能夠提前觀察市場可能出現的轉折位置。全書系統介紹江恩角度線、45°角度線、輪中輪、九方圖、12主控圖等經典工具，說明如何利…"
  },
  {
    "id": "article-054",
    "slug": "monthly-recommendation-9786264283953",
    "title": "古典文學裡，有人這樣活過：從詩歌、文章、戲曲到小說，讀懂古典文學的流變、形式與精神世界",
    "publisher": "複刻文化",
    "isbn": "9786264283953",
    "coverImage": "/assets/books/9786264283953.jpg",
    "category": "醫療保健",
    "tagline": "古人寫下的，不只是風花雪月 還有理想受挫、生命無常與人間深情 詩歌、文章、戲曲、小說 走進古人真實而遼闊的精神世界── ▎從詩歌聽見古人的心事 從《詩經》開始，古典文學便與現實人生緊密相連。祭祀祖先、讚美良善政治、諷刺昏亂朝政、書寫戰爭離別、描摹男女情愛，都成為早期詩歌的重要內容。《詩經》的情...",
    "publishDate": "2026-07-01",
    "excerpt": "古人寫下的，不只是風花雪月 還有理想受挫、生命無常與人間深情 詩歌、文章、戲曲、小說 走進古人真實而遼闊的精神世界── ▎從詩歌聽見古人的心事 從《詩經》開始，古典文學便與現實人生緊密相連。祭祀祖先、讚美良善政治、諷刺昏亂朝政、書寫戰爭離別、描摹男女情愛，都成為早期詩歌的重要內容。《詩經》的情感多半溫厚克制，卻能在平實語言中寫出悠長滋味。楚辭則帶來截然不同的美感，它華麗、熱烈、奇幻，尤其屈原作品中的孤獨、高潔與悲憤，使古典文學第一次鮮明…"
  },
  {
    "id": "article-055",
    "slug": "monthly-recommendation-9786264169660",
    "title": "乳此安心，乳房健康100問：疼痛×硬塊×篩檢×治療康復，醫師解答現代人最常見的100個乳房健康疑問",
    "publisher": "崧燁文化",
    "isbn": "9786264169660",
    "coverImage": "/assets/books/9786264169660.jpg",
    "category": "醫療保健",
    "tagline": "乳房疼痛、結節、囊腫，到底要不要緊？從自我檢查到影像判讀，從乳癌風險到治療康復──別讓網路謠言製造焦慮，用100個問答讀懂乳房健康！ ▎以問答打開乳房健康的第一道門 本書寫給大眾讀者的乳房健康與乳癌科普書，以貼近日常疑問的問答形式，帶領讀者從認識乳房開始，逐步理解乳房疾病、乳癌風險、檢查方式、...",
    "publishDate": "2026-07-01",
    "excerpt": "乳房疼痛、結節、囊腫，到底要不要緊？從自我檢查到影像判讀，從乳癌風險到治療康復──別讓網路謠言製造焦慮，用100個問答讀懂乳房健康！ ▎以問答打開乳房健康的第一道門 本書寫給大眾讀者的乳房健康與乳癌科普書，以貼近日常疑問的問答形式，帶領讀者從認識乳房開始，逐步理解乳房疾病、乳癌風險、檢查方式、診斷流程、治療選擇與康復管理。全書語氣親切，將醫學知識轉化為容易理解的生活語言，既能幫助讀者建立正確觀念，也能減少面對乳房異常或乳癌時的恐懼與焦慮…"
  },
  {
    "id": "article-056",
    "slug": "monthly-recommendation-9786264084994",
    "title": "GDP成長肥到誰？李嘉圖帶你讀懂房價、薪資、稅負與全球貿易的成本轉嫁：從生活成本到薪資報酬，從企業獲利到全球貿易，揭開經濟成長背後的利益流向",
    "publisher": "財經錢線",
    "isbn": "9786264084994",
    "coverImage": "/assets/books/9786264084994.jpg",
    "category": "醫療保健",
    "tagline": "GDP上升之後，收益究竟流向誰？ 有資源的國家，為何未必拿走最多收益？ 為什麼同一間房子換個位置，價格就差好幾倍？ 經濟成長是工資、利潤、地租與稅收的重新分配 當生產成果進入市場，財富便開始在不同位置間流動 【價格如何形成】 本書先從價值與價格談起，帶讀者拆開市場標價背後的生產條件。商品價格不...",
    "publishDate": "2026-07-01",
    "excerpt": "GDP上升之後，收益究竟流向誰？ 有資源的國家，為何未必拿走最多收益？ 為什麼同一間房子換個位置，價格就差好幾倍？ 經濟成長是工資、利潤、地租與稅收的重新分配 當生產成果進入市場，財富便開始在不同位置間流動 【價格如何形成】 本書先從價值與價格談起，帶讀者拆開市場標價背後的生產條件。商品價格不是單純由供需決定，也不只是材料、工時與利潤相加，而是勞動、資本、技術、品牌、通路、風險與制度共同作用的結果。書中進一步區分自然價格與市場價格，說明…"
  }
] as const;

